/**
 * List of keys in a KeyboardEvent
 */
export enum KeyEvent {
  Enter = 'Enter'
}
